import React, { useEffect, useState } from 'react';
import logoFooter from 'assets/images/turkish-airlines-logo/logo-turkishairlines.svg';
import 'assets/scss/page/system-login-style.scss';
import OnboardPassword from '../../component/base/onboard-password/OnboardPassword';
import OnboardButton from '../../component/base/onboard-button-component/OnboardButton';
import OnboardInput from '../../component/base/onboard-input/OnboardInput';
import { checkRegister, clearRegister, encryptDataWithPublicKey } from '../../util/SystemLoginManager';
import logoLoading from '../../assets/images/loading_alternative.gif';
import { isAdminAccess, nowLogin, publicKey, systemLogin } from '../../api/ifec-verify-services/IfecVerifyService';
import trFlag from '../../assets/images/flags/tr.svg';
import enFlag from '../../assets/images/flags/en.svg';
import parse from 'html-react-parser';

const SystemLoginPage = (props) => {

    const { t, handleInformation, navigate } = props.props;

    const [loading, setLoading] = useState(false);
    const [errorVisible, setErrorVisible] = useState(false);
    const [error, setError] = useState({ username: '', password: '' });
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [pageLang, setPageLang] = useState('tr');
    const [adminSelectionVisible, setAdminSelectionVisible] = useState(false);

    const lang = {
        tr: {
            pageTitle: 'Onboard Portal - Simülasyon',
            heroTitle: 'Uçak İçi İnternet Simülasyonu',
            subtitle: 'Uçak içi internet sistemini güvenli bir şekilde öğrenmek için sistem hesabınız ile giriş yapın.',
            tag1: 'TK WiFi',
            tag2: 'Güvenli Erişim',
            tag3: 'İnternet Sistemi',
            loginTitle: 'Sistem Girişi',
            loginText: 'Yetkili kullanıcı bilgilerinizi girerek devam edin.',
            username: 'Kullanıcı Adı',
            password: 'Şifre',
            loginButton: 'Giriş Yap',
            invalidLogin: 'Girmiş olduğunuz bilgiler doğru değil. Lütfen tekrar deneyiniz.',
            usernameRequired: 'Lütfen kullanıcı adınızı giriniz.',
            passwordRequired: 'Lütfen şifrenizi giriniz.',
            adminSelectionTitle: 'Yönlendirme Seçimi',
            adminSelectionText: 'Admin erişiminiz var. Hangi ekrana gitmek istiyorsunuz?',
            adminSelectionAdmin: 'Admin Sayfası',
            adminSelectionSimulation: 'Simülasyon'
        },
        en: {
            pageTitle: 'Onboard Portal - Simulation',
            heroTitle: 'In-Flight Internet Simulation',
            subtitle: 'To safely learn how to use the in-flight internet system, log in with your system account.',
            tag1: 'TK WiFi',
            tag2: 'Secure Access',
            tag3: 'Internet System',
            loginTitle: 'System Login',
            loginText: 'Continue by entering your authorized user credentials.',
            username: 'Username',
            password: 'Password',
            loginButton: 'Sign In',
            invalidLogin: 'The credentials you entered are incorrect. Please try again.',
            usernameRequired: 'Please enter your username.',
            passwordRequired: 'Please enter your password.',
            adminSelectionTitle: 'Navigation Choice',
            adminSelectionText: 'You have admin access. Which page do you want to open?',
            adminSelectionAdmin: 'Admin Page',
            adminSelectionSimulation: 'Simulation'
        }
    };

    useEffect(() => {
        clearRegister();

        if (location.pathname !== '/simulation')
            handleInformation('system_login');

        document.body.classList.add('modal-open');
        return () => {
            document.body.classList.remove('modal-open');
        };
    }, []);

    const valid = () => {
        if (username.length > 0 && password.length > 0) {
            setLoading(true);

            publicKey().then((response) => {
                let publicKey = response.data.publicKey;

                if (publicKey === null || publicKey === undefined) {
                    setLoading(false);
                    setErrorVisible(true);
                    return;
                }

                systemLogin(encryptDataWithPublicKey(publicKey, username), encryptDataWithPublicKey(publicKey, password))
                    .then((response) => {
                        setLoading(false);
                        if (response.data.success) {
                            localStorage.removeItem('acceptRights');
                            localStorage.setItem('rightPanelLang', pageLang);
                            checkRegister(response.data.email, username, response.data.token);
                            nowLogin();
                            checkAdminAndNavigate();
                        } else {
                            setErrorVisible(true);
                        }
                    }).catch(e => {
                    setLoading(false);
                    setErrorVisible(true);
                });
            }).catch(e => {
                setLoading(false);
                setErrorVisible(true);
            });
        } else {
            setError({
                username: username === '' ? lang[pageLang].usernameRequired : '',
                password: password === '' ? lang[pageLang].passwordRequired : ''
            });
        }
    };

    const isAdminUser = (response) => {
        const data = response?.data;
        if (typeof data === 'boolean') return data;
        if (typeof data?.data === 'boolean') return data.data;
        if (typeof data?.isAdmin === 'boolean') return data.isAdmin;
        return false;
    };

    const checkAdminAndNavigate = () => {
        isAdminAccess()
            .then((response) => {
                if (isAdminUser(response)) {
                    setAdminSelectionVisible(true);
                    return;
                }
                navigate('/');
            })
            .catch(() => {
                navigate('/');
            });
    };

    return (
        <div className="system-login-page-root">
            {loading &&
                <div className="system-login-page-loading">
                    <div className="system-login-page-loading-opa"></div>
                    <img className="splash-screen-root-img" alt="Logo" src={logoLoading}></img>
                </div>
            }

            <div className="system-login-page-shell">
                <div className="system-login-page-hero">
                    <h1>
                        <img alt="logo" width={34} src="/favicon.ico" />
                        {parse(lang[pageLang].pageTitle)}
                    </h1>
                    <div>
                        <h2>{lang[pageLang].heroTitle}</h2>
                        <p className="system-login-page-subtitle">
                            {lang[pageLang].subtitle}
                        </p>
                        <div className="system-login-page-tags">
                        <span className="system-login-page-tag-wifi">
                            <div className="system-login-page-wifi-mark" aria-hidden="true">
                                <span></span>
                                <span></span>
                                <span></span>
                                <i></i>
                            </div>
                            {lang[pageLang].tag1}
                        </span>
                            <span>{lang[pageLang].tag2}</span>
                            <span>{lang[pageLang].tag3}</span>
                        </div>
                    </div>
                    <img className="system-login-page-footer-logo" width={200} alt="Logo" src={logoFooter}></img>
                </div>

                <div className="system-login-page-card">
                    <div>
                        <h3>{lang[pageLang].loginTitle}</h3>
                        <div className="system-login-page-lang-switch">
                            <button className={pageLang === 'tr' ? 'active' : ''} onClick={() => setPageLang('tr')}>
                                <img src={trFlag} alt="Turkish" />
                                <span>TR</span>
                            </button>
                            <button className={pageLang === 'en' ? 'active' : ''} onClick={() => setPageLang('en')}>
                                <img src={enFlag} alt="English" />
                                <span>EN</span>
                            </button>
                        </div>
                    </div>
                    <p>{lang[pageLang].loginText}</p>
                    <OnboardInput
                        placeholder={lang[pageLang].username}
                        onChange={(e) => {
                            setUsername(e);
                        }}
                        error={error.username}
                        value={username}
                    />

                    <OnboardPassword placeholder={lang[pageLang].password}
                                     onChange={(e) => {
                                         setPassword(e);
                                     }}
                                     error={error.password} isNotNumber
                                     value={password} />

                    {errorVisible &&
                        <span className="system-login-page-error">{lang[pageLang].invalidLogin}</span>
                    }

                    <div className="h-8"></div>

                    <OnboardButton label={lang[pageLang].loginButton} onClick={() => valid()} />
                </div>
            </div>

            {adminSelectionVisible && (
                <div className="system-login-admin-modal-overlay">
                    <div className="system-login-admin-modal">
                        <h4>{lang[pageLang].adminSelectionTitle}</h4>
                        <p>{lang[pageLang].adminSelectionText}</p>
                        <div className="system-login-admin-modal-buttons">
                            <button
                                className="admin"
                                onClick={() => {
                                    setAdminSelectionVisible(false);
                                    navigate('/admin');
                                }}>
                                {lang[pageLang].adminSelectionAdmin}
                            </button>
                            <button
                                className="simulation"
                                onClick={() => {
                                    setAdminSelectionVisible(false);
                                    navigate('/');
                                }}>
                                {lang[pageLang].adminSelectionSimulation}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SystemLoginPage;
